






































































import { Component, Prop, Vue } from 'vue-property-decorator';

import Policy from '@/services/Policy';
import * as Sentry from '@sentry/browser';

// Components
import Loading from '@/components/Global/Loading.vue';
import TextField from '@/components/Form/TextField.vue';
import SelectField from '@/components/Form/SelectField.vue';

@Component({
	name: 'QuotesList',
	components: {
		Loading,
		TextField,
		SelectField,
	},
})
export default class ClientsList extends Vue {
	@Prop() private clientsList: any;
	private paginate: string[];
	private error: boolean;
	private loading: boolean;
	private className: string;
	private searchText: string;
	private filterSearchType: string;
	private updatedClientsList: any[];
	constructor() {
		super();
		this.updatedClientsList = [];
		this.paginate = ['updatedClientsList'];
		this.error = false;
		this.loading = true;
		this.searchText = '';
		this.filterSearchType = 'Name';
	}

	private async created() {
		try {
			// Get Users
			this.updatedClientsList = this.clientsList;

			this.updatedClientsList.forEach(client => {
				const keys: string[] = Object.keys(client.risks);
				if (!client.risks[keys[0]].insured.name.includes('null')) {
					client.policy_holder_name = client.risks[keys[0]].insured.name;
				} else {
					client.policy_holder_name = client.risks[keys[0]].insured.org;
				}
			});
		} catch (e) {
			Sentry.captureException(e);
			this.error = true;
		} finally {
			this.loading = false;
		}
	}

	private loadClient(client) {
		this.$router.push({
			name: 'BrokerClientDetails',
			params: {
				client,
			},
		});
	}
	private search() {
		this.updatedClientsList = this.clientsList;
		this.searchText = this.searchText.toLowerCase();

		if (this.searchText) {
			const regex = new RegExp(this.searchText, 'g');
			const filteredClients = this.clientsList
				.map(client => {
					if (
						this.filterSearchType === 'Name' &&
						client.risks[0].insured.name !== undefined &&
						client.risks[0].insured.name.match(regex)
					) {
						return client;
					} else if (
						this.filterSearchType === 'Number' &&
						client.policy_number !== undefined &&
						client.policy_number.match(regex)
					) {
						return client;
					}
				})
				.filter(client => {
					if (client !== undefined) {
						return client;
					}
				});

			this.updatedClientsList = filteredClients;
		} else {
			this.updatedClientsList = this.clientsList;
		}

		console.log('clients', this.updatedClientsList);
	}
	private changeSearchType($event) {
		this.filterSearchType = $event.target.value;
	}
}
